<!-- reminder-dialog.component.html -->
   <div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">New Service Reminder</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
<div class="reminder-wrapper">
  <!-- Reminder name -->
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Reminder name</mat-label>
    <input matInput placeholder="Reminder name" />
  </mat-form-field>

  <!-- Trigger date & time -->
  <div class="section">
    <h4>Trigger date and time</h4>
    <div class="chip-row">
      <mat-chip-list aria-label="Fish selection">
        <mat-chip color="accent" selected>February 5, 2026</mat-chip>
        <mat-chip color="accent" selected>12:00 PM - 01:00 PM</mat-chip>
    </mat-chip-list>

    </div>
  </div>

  <!-- Frequency -->
  <div class="section">
    <h4>Frequency</h4>
    <div class="chip-row tmtmt" style="margin-bottom: 20px;">
          <mat-chip-list aria-label="Fish selection">
        <mat-chip color="primary" selected>One time</mat-chip>
        <mat-chip color="accent" selected>Recurring</mat-chip>
    </mat-chip-list>
    </div>

      <mat-form-field appearance="outline" class="w-100">
    <mat-label>Frequency interval</mat-label>
    <input matInput placeholder="Reminder name" />
  </mat-form-field>
  </div>

  <!-- Notes -->
   <div class="notifi_case">
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Notification/notes</mat-label>
    <textarea matInput rows="3"></textarea>
  </mat-form-field>
</div>
  <!-- Footer -->
  <div class="dialog-footer">
    <button mat-button>Cancel</button>
    <button mat-flat-button class="createreminderbtn" color="primary">
      Create new reminder
    </button>
  </div>
</div>
